const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const Variants = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "VARIANTS_REQUEST":
      return { loading: true, error: false, data: [] };
    case 'VARIANTS_ERROR':
      return { loading: false, error: true, data: []};
    case "VARIANTS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default Variants;
